// src/adminAxios.js
import axios from 'axios';

const adminAxios = axios.create({
  baseURL: 'http://localhost:5000/api/admin'
});

export default adminAxios;
